module.exports = __webpack_public_path__ + "static/media/arrow-l.6430ea2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/arrow-l.svg
// module id = 1238
// module chunks = 0